import React from "react";
import "./DashboardCatalogSkeleton.css";

function Skel({ className = "" }) {
  return <span className={`dash-skel ${className}`.trim()} aria-hidden="true" />;
}

function SectionHeaderSkeleton() {
  return (
    <div className="v1-category-header dash-skel-header">
      <div>
        <Skel className="dash-skel--title" />
        <Skel className="dash-skel--desc" />
      </div>
    </div>
  );
}

function ImageCardSkeleton({ imageClass = "" }) {
  return (
    <div className="v1-design-item dash-skel-card" aria-hidden="true">
      <div className={`v1-design-item-image ${imageClass}`.trim()}>
        <Skel className="dash-skel--block" />
      </div>
      <div className="v1-design-item-footer">
        <Skel className="dash-skel--label" />
      </div>
    </div>
  );
}

function TextCardSkeleton() {
  return (
    <div className="v1-design-item v1-design-item--text dash-skel-card dash-skel-card--text" aria-hidden="true">
      <Skel className="dash-skel--icon" />
      <div className="dash-skel-text-lines">
        <Skel className="dash-skel--label" />
        <Skel className="dash-skel--subtitle" />
      </div>
    </div>
  );
}

function ToolsPageCardSkeleton() {
  return (
    <div className="dash-skel-tools-card" aria-hidden="true">
      <div className="dash-skel-tools-card__media">
        <Skel className="dash-skel--block" />
      </div>
      <div className="dash-skel-tools-card__footer">
        <Skel className="dash-skel--label" />
      </div>
    </div>
  );
}

/** Matches dashboard tool sections: trending image row + compact text-card rows. */
export function DashboardToolsSkeleton() {
  return (
    <div className="dash-skel-root" aria-busy="true" aria-live="polite" aria-label="Loading tools">
      <div className="v1-design-category v1-category-all-designs">
        <SectionHeaderSkeleton />
        <div className="v1-category-grid">
          {Array.from({ length: 5 }, (_, i) => (
            <ImageCardSkeleton key={`trend-${i}`} imageClass="dash-skel-image--trending" />
          ))}
        </div>
      </div>

      {[0, 1].map((row) => (
        <div key={`text-row-${row}`} className="v1-design-category v1-category-editing-tools">
          <SectionHeaderSkeleton />
          <div className="v1-category-grid">
            {Array.from({ length: 4 }, (_, i) => (
              <TextCardSkeleton key={`text-${row}-${i}`} />
            ))}
          </div>
        </div>
      ))}
    </div>
  );
}

/** Matches design-category preset rows (6-col image cards). */
export function DashboardCategoriesSkeleton() {
  return (
    <div className="dash-skel-root" aria-busy="true" aria-live="polite" aria-label="Loading design categories">
      {[0, 1].map((row) => (
        <div
          key={`cat-row-${row}`}
          className="v1-design-category v1-category-market-places v1-category-fixed-grid v1-category-cols-6"
        >
          <SectionHeaderSkeleton />
          <div className="v1-category-grid">
            {Array.from({ length: 6 }, (_, i) => (
              <ImageCardSkeleton key={`cat-${row}-${i}`} imageClass="dash-skel-image--preset" />
            ))}
          </div>
        </div>
      ))}
    </div>
  );
}

/** Matches Tools page BeforeAfterToolCard grid. */
export function ToolsPageSkeleton({ sections = 3, cardsPerSection = 5 }) {
  return (
    <div className="dash-skel-root" aria-busy="true" aria-live="polite" aria-label="Loading tools">
      {Array.from({ length: sections }, (_, s) => (
        <section key={`tools-sec-${s}`} className="tools-page__section">
          <div className="tools-page__section-header dash-skel-header">
            <Skel className="dash-skel--title dash-skel--title-lg" />
            <Skel className="dash-skel--desc dash-skel--desc-lg" />
          </div>
          <div className="tools-page__grid">
            {Array.from({ length: cardsPerSection }, (_, i) => (
              <ToolsPageCardSkeleton key={`tools-card-${s}-${i}`} />
            ))}
          </div>
        </section>
      ))}
    </div>
  );
}
